export const intersectionObserver = (window) => (el, s) => {
  window.requestAnimationFrame(() => {
    // TODO: add small looping to find node
    if (!el.node) {
      return
    }
    new window.IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        let t = null
        if (entry.isIntersecting) {
          t = setTimeout(() => {
            const { scale } = window.scope.positions
            if (!el.content) {
              el.set(scale < 0.5 ? '123' : el.data.content(el, s))
            }
            window.requestAnimationFrame(() => (el.node.style.opacity = 1))
            clearTimeout(t)
          }, 35)
        } else {
          clearTimeout(t)
          if (el.content) {
            el.removeContent()
          }
        }
      })
    }).observe(el.node)
  })
}
